import type { ReactNode } from 'react';

export const symbol_fan_indirect: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m510-195 36-35q9-8 21-8.5t21 8.5q9 9 9 21t-9 21l-87 87q-9 9-21 9t-21-9l-87-87q-9-9-8.5-21t9.5-21q9-9 21-9t21 9l35 35v-242q0-13 8.5-21.5T480-467q13 0 21.5 8.5T510-437v242ZM155-325l36 37q9 9 9 20.5t-9 20.5q-9 9-21 9t-21-9L41-355l108-108q9-9 21-9t21 9q9 9 9 21t-9 21l-36 36h129v-205q0-13 8.5-21.5T314-620q13 0 21.5 8.5T344-590v205q0 24-18 42t-42 18H155Zm651 0H677q-24 0-42-18t-18-42v-205q0-13 8.5-21.5T647-620q13 0 21.5 8.5T677-590v205h129l-36-36q-9-9-9-21t9-21q9-9 21-9t21 9l87 87q9 9 9 21.5t-9 21.5l-87 87q-9 9-21 8.5t-21-9.5q-9-9-9-21t9-21l36-36ZM80-780q0-24 18-42t42-18h680q24 0 42 18t18 42v212q0 13-8.5 21.5T850-538q-13 0-21.5-8.5T820-568v-212H140v212q0 13-8.5 21.5T110-538q-13 0-21.5-8.5T80-568v-212Z"
		/>
	</svg>
);
